<template>
  <div class="vx-input-group flex mb-0">
    <div class="vx-input-group-default flex-grow">
      <div>
        <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
          <div class="vs-con-input" :style="{ 'cursor': cursor }" @click="handleClick()">
            <input class="vs-inputx vs-input--input normal hasValue" :type="type" :disabled="isDisabled" :value="value"
              @input="$emit('input', $event.target.value)" :name="name" :maxlength="maxlength"
              :placeholder="placeholder" style="border: 1px solid rgba(0, 0, 0, 0.2);" @focusout="handleFocusOut()">
          </div>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 524288
    },
    placeholder: {
      type: String,
      default: ''
    },
    cursor: {
      type: String,
      default: 'default'
    },
  },
  watch: {

  },
  data() {
    return {
      text: ''
    };
  },
  methods: {
    handleFocusOut() {
      this.$emit("onTextFieldFocusOut");
    },
    handleClick() {
      this.$emit("onTextFieldClick");
    }
  }
};
</script>

<style scoped>
/* Add component-specific styles here */
</style>
